import { FunctionComponent, useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './SidebarMenu.module.css';
import { Image } from 'react-bootstrap';
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import { ASSESTS } from '../../../constant/assest';
import { UNAUTH_ROUTES } from '../../../routing';

interface SidebarMenuProps {
    className?: string;
}

const SidebarMenu: FunctionComponent<SidebarMenuProps> = ({ className }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [parentActive, setParentActive] = useState<string>("");
    const [activeItem, setActiveItem] = useState<string>("");

    useEffect(() => {
        let activeFound = false;
        
        for (const parent of UNAUTH_ROUTES) {
            const parentPath = parent.routeProps.path as string;
            if (parent.children) {
                for (const child of parent.children) {
                    const childPath = child.routeProps.path || '';
                    const fullPath = (child.routeProps.index || childPath === parentPath) ? parentPath : `${parentPath}/${childPath}`;
                    
                    if (matchPath(fullPath, location.pathname)) {
                        setActiveItem(child.displayName as string);
                        setParentActive(parent.displayName as string);
                        activeFound = true;
                        break;
                    }
                }
            }
            if (activeFound) break;

            if (parentPath === location.pathname) {
                setActiveItem(parent.displayName as string);
                setParentActive('');
                activeFound = true;
                break;
            }
        }
        if (!activeFound) {
            setActiveItem('');
            setParentActive('');
        }    
    }, [location.pathname]);

    return (
        <div className={cn(styles.menuWrapper, className)}>
            {UNAUTH_ROUTES.map((item) => {
                const isActive = activeItem === item.displayName;
                const hasChildren = !!item.children?.length;

                return (
                    item.showInNavMenu &&
                    <div
                        key={item.displayName}
                        className={cn(styles.menuItem, {
                            [styles.hasChildren]: hasChildren,
                            [styles.activeItem]: isActive,
                        })}
                    >
                        <button
                            className={styles.menuLink}
                            onClick={() => {
                            if (item.displayName === 'Campaigns' && hasChildren && item.children) {
                                const firstVisibleChild = item.children.find(child => child.showInNavMenu);
                                if (firstVisibleChild) {                                    
                                    const parentPath = item.routeProps.path as string;
                                    const childPath = firstVisibleChild.routeProps.path || '';                                    
                                    const fullPath = (firstVisibleChild.routeProps.index || childPath === parentPath) ? parentPath : `${parentPath}/${childPath}`;
                                    navigate(fullPath);
                                } else {
                                    navigate(item.routeProps.path as string);
                                }
                            } else {
                                navigate(item.routeProps.path as string);
                            }
                        }}
                        >
                            {item.icon && (
                                <div className={styles.menuIcon}>
                                    <Image
                                        src={item.icon}
                                        width={30}
                                        height={30}
                                        alt={item.displayName}
                                    />
                                </div>
                            )}
                            <div className={styles.menuText}>{item.displayName}</div>
                            {hasChildren && (isActive || parentActive === item.displayName) && (
                                <div className={styles.menuArrow}>
                                    <Image src={ASSESTS.CARRETDOWN} alt={item.displayName} />
                                </div>
                            )}
                        </button>

                        {hasChildren && (isActive || parentActive === item.displayName) && (
                            <div className={styles.childrenMenu}>
                                {item.children!.map((child) => {

                                    const handleChildClick = () => {
                                        const parentPath = item.routeProps.path as string;
                                        const childPath = child.routeProps.path || '';
                                        if (child.routeProps.index || childPath === parentPath) {
                                            navigate(parentPath);
                                        } else {
                                            if (childPath.includes(':')) {
                                                navigate(`${parentPath}/${childPath.split('/:')[0]}`);
                                            } else {
                                                navigate(`${parentPath}/${childPath}`);
                                            }
                                        }
                                        setParentActive(item.displayName as string);
                                    };

                                    return (
                                        child.showInNavMenu &&
                                        <div
                                            className={cn(styles.childrenItem, {
                                                [styles.activeItem]: activeItem === child.displayName,
                                            })}
                                            key={child.displayName}
                                        >
                                            <button
                                                className={styles.childrenLink}
                                                onClick={handleChildClick}
                                            >
                                                <div className={styles.childrenText}>{child.displayName}</div>
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default SidebarMenu;